import { Spinner } from './primitives/Spinner'

export function LoadingSpinner({ message }) {
  return (
    <Spinner label={message || 'Loading'} visibleLabel={Boolean(message)} />
  )
}
